import { Link } from "react-router-dom"
import Icon from "./Icon"
import Button from "./Button"


const Menu = props => {
  const { isMobile } = props

  return (
    <div id="Menu">
      <Link to="/">
        <Icon url={require("../assets/img/home.svg").default} alt={"home"} />
        <p className="primary">For You</p>
      </Link>
      <Link to="/following">
        <Icon
        url={require("../assets/img/following.svg").default} 
        alt={"following"}
        />
        <p className="secondary">Following</p>
      </Link>
      <hr className="d-none d-lg-block" />
      <p className="d-none d-lg-block">
        Log in to follow creators, like videos, and view comments.
      </p>
      <Button type={isMobile ? "primary" : "secondary"} text={"Log in"} />
    </div>
  )
}

export default Menu